export default __webpack_public_path__ + "static/media/021-snooker.6162bc58.svg";